export default __webpack_public_path__ + "hotel-letter-h-sign-inside-a-black-rounded-square.png";